/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

// Used to generate the requirejs layers bundle
// Only declare the entry points, not all modules!
define([
	'./VisualizationPanelView'
], function() {
	'use strict';
});
